import { Title } from '@app/components/core/typography/Title'
import Row from '@app/components/layout/Row'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'

import { PeopleToMessagePanel } from './sections/messages/PeopleToMessagePanel'
import { useState, useCallback } from 'react'

import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { ConversationPanel } from './sections/messages/ConversationPanel'
import { ConversationsPanel } from './sections/messages/ConversationsPanel'
import useMediaQuery from '@app/util/useMediaQuery'

export const ProfileMessages = ({
  conversationId,
}: {
  conversationId?: number
}) => {
  const isMobile = useMediaQuery()
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.messages
  const [_, navigate] = useLocation()
  const [activeConverstaion, setActiveConversation] = useState<{
    title: string
    unread: boolean
  }>({ title: '', unread: false })

  const closeConversation = () => {
    navigate(pages.dashboardMessages)
    setActiveConversation({ title: '', unread: false })
  }

  const handleSetActiveConversation = useCallback(
    (title: string, unread: boolean) => {
      setActiveConversation({ title, unread })
    },
    [],
  )

  const showConverstaions = !isMobile || !conversationId

  return (
    <DashboardPageLayout gap="0">
      <Title.H3>{translations.messages}</Title.H3>
      <Row gap="1.5rem" style={{ alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <div
          style={{ display: showConverstaions ? undefined : 'none' }}
          aria-hidden={!showConverstaions}
        >
          <ConversationsPanel
            conversationId={conversationId}
            setActiveConversation={handleSetActiveConversation}
          />
        </div>
        {conversationId ? (
          <ConversationPanel
            conversationId={conversationId}
            conversationTitle={activeConverstaion.title}
            unread={activeConverstaion.unread}
            onClose={closeConversation}
          />
        ) : (
          <PeopleToMessagePanel />
        )}
      </Row>
    </DashboardPageLayout>
  )
}
